export class IncludeProperties {
    comments = false;
    description = false;
    applicableOn = false;
    objective = false;
    method = false;
    parameterCode = false;
    parameterName = false;
    CASNumber = false;

    constructor() {
        this.comments = false;
        this.description = false;
        this.applicableOn = false;
        this.objective = false;
        this.method = false;
        this.parameterCode = false;
        this.parameterName = false;
        this.CASNumber = false;
    }
}
